import React, { useState, useMemo, useEffect, use } from 'react';
import FilterTabs from './FilterTabs';
import AccountCard from './AccountCard';
import moment from 'moment';
import StatsCard from './StatsCard';
import { getCrifAnalysis,addNewObligaitonAPI,getTotalObligationAmountById,getTotalObligationAmountExceptCreditById,getCrifAnalysisExceptcredit } from '../../../Analysis/analysisactionCreator';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component';
import SpinnerLoader from '../../../../../presentationals/Loader/Loader.component';
// import IconImg from '../../../../../../../../../'
// import IconImg from '../../../../../images/ObligationPopupImage.svg'

const CreditCrifDashboard = ({ admin, allDetail }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [crifAnalysisData, setCrifAnalysisData] = useState([]);
  const [addNewObligationPopup, setAddNewObligationPopup] = useState({ show: false, data: {} })
  const [loader, setloader] = useState(false)
  const [loading, setloading] = useState(false)
  const [popup, setPopup] = useState({ show: false, popupStatus: '' })
  const [crifData,setcrifData]=useState([])
  const [amount,setAmount] =useState({totalObligation:0,totalObligationExceptcredit:0})


  const handleAddNewObligationPopup = (show, data) => {
    console.log(data);
    if (show) {
      var payload = {
        disbursedAmount: data?.disbursedAmt ?? "",
        disburseDate: moment(data?.disburseDate).format('YYYY-MM-DD') ?? "",
        accountType: data?.accType ?? "",
        tenure: data?.tenure ?? "",
        roi: data?.roi ?? "",
        deviation: data?.deviation ?? ""
      };
      setAddNewObligationPopup({ show: true, data: payload });
      } else {
      setAddNewObligationPopup({ show: show, data: data });

    }
  }
  const handleSaveObligation = () => {
    setloader(true)
    const dueDate = moment(addNewObligationPopup?.data?.disburseDate).format('DD-MM-YYYY')
    const obj = { ...addNewObligationPopup?.data, disburseDate: dueDate }
    addNewObligaitonAPI(allDetail?.userId, allDetail?.loanId, obj, (callback) => {
      console.log(callback)
      setloader(false)
      if (callback == "success") {
        setAddNewObligationPopup({show:false,data:{}});
        // getCrifLoansFunction(InitalDate('fromDate'), InitalDate('toDate'))
        fetchCrifAnalysis(0)
        setPopup({ show: true, popupStatus: "Data Saved" })
      } else {
        setPopup({ show: true, popupStatus: "Error: Please Try Again later!" })
      }
      removePopup()
    })
  }

  const handleObligationAmountApi = ()=>{
    setloader(true)
    getTotalObligationAmountById(allDetail?.userId, allDetail?.loanId,callback=>{
      setloader(false)
      setAmount((prev)=>({...prev,totalObligation:callback || 0}))
    })
    getTotalObligationAmountExceptCreditById(allDetail?.userId, allDetail?.loanId,callback=>{
      setloader(false)
      setAmount((prev)=>({...prev,totalObligationExceptcredit:callback || 0}))
    })
  }
  
    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }
  const filteredData = useMemo(() => {
    if (!Array.isArray(crifAnalysisData)) return [];

    let filtered = [...crifAnalysisData];

    // Apply filter
    if (activeFilter === 'include') {
      filtered = filtered.filter(item => item.includedInObligation === true);
    } else if (activeFilter === 'exclude') {
      filtered = filtered.filter(item => item.includedInObligation === false);
    } else if(activeFilter == "includeExceptcredit"){
      filtered = crifData
    }

    // Apply search
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.accType?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.accountStatus?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filtered;
  }, [activeFilter, searchTerm, crifAnalysisData]);
  const stats = useMemo(() => {
    if (!Array.isArray(crifAnalysisData)) {
      return {
        totalAccounts: 0,
        includedAccounts: 0,
        excludedAccounts: 0,
        totalCurrentBalance: 0,
        totalEMI: 0,
        totalIncludedExceptcredit:0
      };
    }

    const totalAccounts = crifAnalysisData.length;
    const includedAccounts = crifAnalysisData.filter(item => item.includedInObligation).length;
    const excludedAccounts = totalAccounts - includedAccounts;
    const totalIncludedExceptcredit = Array.isArray(crifData) ? crifData?.length : 0

    const totalCurrentBalance = crifAnalysisData.reduce((sum, item) => {
      const balance = typeof item.currentBal === 'string'
        ? parseFloat(item.currentBal.replace(/,/g, ''))
        : item.currentBal;
      return sum + (isNaN(balance) ? 0 : balance);
    }, 0);

    const totalEMI = crifAnalysisData.reduce((sum, item) => {
      return sum + (item.emiAmt || 0);
    }, 0);

    return {
      totalAccounts,
      includedAccounts,
      excludedAccounts,
      totalCurrentBalance,
      totalEMI,
      totalIncludedExceptcredit
    };
  }, [crifAnalysisData]);

  const fetchCrifAnalysis = (regen) => {
    setloading(true);
    console.log(admin, allDetail)
    getCrifAnalysis(allDetail.userId, allDetail.loanId,regen, (callback) => {
      if (callback && Array.isArray(callback)) {
        setCrifAnalysisData(callback);
      } else {
        console.warn("Invalid CRIF analysis data", callback);
      }
    });
    
    getCrifAnalysisExceptcredit(allDetail.userId, allDetail.loanId,callback=>{
       if (callback && Array.isArray(callback)) {
        setcrifData(callback);
        }
        else {
        console.warn("Invalid CRIF analysis data", callback);
      }
    })
    setloading(false);
  };
  const handleAddObligationDataFunction = (e) => {
    e.preventDefault()
    const { name, value } = e.target;
    setAddNewObligationPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: value,
      },
    }));
  }

  useEffect(() => {
    fetchCrifAnalysis(0);
    handleObligationAmountApi()
  }, []);

  const handleRegenrate =()=>{
    fetchCrifAnalysis(1);
  }

  return (
    <div className="credit-dashboard" style={{paddingTop:window.innerWidth > 1800 ? "80px" : "40px"}}>
      {loading && <SpinnerLoader />}
      <div className="stats-container">
        <div className="stats-grid">
          <StatsCard
            title="Total Accounts"
            value={stats.totalAccounts}
            iconClass="fa-credit-card"
            color="linear-gradient(135deg, #3b82f6, #2563eb)"
          />
          <StatsCard
            title="Included in Obligation"
            value={stats.includedAccounts}
            iconClass="fa-line-chart"
            color="linear-gradient(135deg, #10b981, #059669)"
          />
          <StatsCard
            title="Total Obligation Amount"
            value={amount?.totalObligation}
            iconClass="fa-inr"
            color="linear-gradient(135deg, #10b981, #059669)"
          />
          <StatsCard
            title="Total Obligation Amount Except Credit"
            value={amount?.totalObligationExceptcredit}
            iconClass="fa-inr"
            color="linear-gradient(135deg, #10b981, #059669)"
          />
        </div>

        <FilterTabs
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          totalCount={stats.totalAccounts}
          includedCount={stats.includedAccounts}
          excludedCount={stats.excludedAccounts}
          totalIncludedExceptcredit={stats.totalIncludedExceptcredit}
          handleRegenrate={handleRegenrate}
        />

        <div className="accounts-section">
          {filteredData.length > 0 ? (
            <div className="accounts-grid">
              {filteredData.map((account, index) => (
                <AccountCard key={index} account={account} index={index} handleAddNewObligationPopup={handleAddNewObligationPopup} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">
                <i className="fa fa-search"></i>
              </div>
              <h3>No accounts found</h3>
              <p>Try adjusting your filters or search terms</p>
            </div>
          )}
        </div>
      </div>
      {addNewObligationPopup.show === true &&
        <>
          {
            loader ?
              <Loader />
              : ''}
          {
            popup?.show == true ?
              <Popup
                closePopup={closePopup}
                popupStatus={popup.popupStatus}
              />
              : ''}
          <div className='background-blur income ObligationCalculatorPopup' style={{ zIndex: '1000' }}>
            <div className={`popup-main container-fluid dbl-border ${addNewObligationPopup.show == true ? "slide-in-right" : "slide-out-right"}`} style={{ top: '20%', padding: '0px', zIndex: '1100', width: 'auto', height: 'auto' }}>

              <div style={{ background: '#1D3557', display: 'flex', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', color: '#fff', padding: '10px 20px ', alignItems: 'center' }}>
                <ArrowBackIosNewIcon style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => handleAddNewObligationPopup(false, {})} />&nbsp;&nbsp;
                <h4>Add New Obligation</h4>
              </div>

              <div className="col-xs-12">
                <div className="row">
                  <div className="col-sm-4 col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Disbursed Amount</label>
                    <input type="number" className='customInput' placeholder='Disbursed Amount' name="disbursedAmount" value={addNewObligationPopup.data?.disbursedAmount} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                  <div className="col-sm-4 col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Date Of Disbursed</label>
                    <input type="date" className='customInput' id='customDateInput' placeholder='Date Of Disbursed' name="disburseDate" value={addNewObligationPopup.data?.disburseDate} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                  <div className="col-sm-4 col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Loan Type</label>
                    <input type="text" className='customInput' placeholder='Loan Type' name="accountType" value={addNewObligationPopup.data?.accountType} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Tenure</label>
                    <input type="number" className='customInput' placeholder='Tenure' name="tenure" value={addNewObligationPopup.data?.tenure} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                  <div className="col-sm-4 col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Interest</label>
                    <input type="number" className='customInput' placeholder='Interest' name="roi" value={addNewObligationPopup.data?.roi} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                  {/* <div className="col-sm-4 col-xs-12 inputss">
                                        <label className="customObligationPopup" htmlFor="">Resources</label>
                                        {/* <input type="text" className='customInput' placeholder='Resources' name="resources" value={addNewObligationPopup.data?.resources} onChange={(e) => handleAddObligationDataFunction(e)} /> 
                                        <select className='customInput' name="resources" value={addNewObligationPopup.data?.resources} onChange={(e) => handleAddObligationDataFunction(e)}>
                                            <option value="">Select Resources</option>
                                            <option value="crif">Crif</option>
                                            <option value="sms">SMS</option>
                                        </select>
                                    </div> */}
                  <div className="col-xs-12 inputss">
                    <label className="customObligationPopup" htmlFor="">Comment</label>
                    <textarea type="text" className='customInput' rows={4} style={{ resize: 'none' }} placeholder='Comment' name="deviation" value={addNewObligationPopup.data?.deviation} onChange={(e) => handleAddObligationDataFunction(e)} />
                  </div>
                  <div className="col-xs-12 inputss" style={{ marginBottom: '15px' }}>

                    <button style={{ background: '#267dff', color: '#fff', padding: '10px', borderRadius: '6px' }} onClick={() => handleSaveObligation()}>Save</button>

                  </div>
                </div>
              </div>
            </div>


          </div>
        </>
      }

    </div>
  );
};

export default CreditCrifDashboard;
